const socialLinks = [
  {
    href: "https://github.com/lutmirapeci",
    icon: "bi-github",
  },
  {
    href: "https://www.linkedin.com/in/lutmira",
    icon: "bi-linkedin",
  },
  {
    href: "https://x.com/lutmirakanani",
    icon: "bi-twitter-x",
  },
  {
    href: "mailto:lutmirapeci@gmail.com",
    icon: "bi-envelope-fill",
  },
  {
    href: "https://wa.me/355698163979",
    icon: "bi-whatsapp",
  },
];

export default socialLinks;
